var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter-icon",
    transform: "translate(-1280 -4666)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 41,
    height: 41,
    rx: 7,
    transform: "translate(1280 4666)",
    fill: "rgba(102,170,71,0.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Twitter_2_",
    d: "M392.917,398.254a10.037,10.037,0,0,1-3.233,1.265,5.018,5.018,0,0,0-3.721-1.654,5.155,5.155,0,0,0-5.087,5.219,5.312,5.312,0,0,0,.138,1.19,14.334,14.334,0,0,1-10.493-5.455,5.311,5.311,0,0,0-.689,2.627,5.251,5.251,0,0,0,2.264,4.344,5,5,0,0,1-2.307-.651v.065a5.189,5.189,0,0,0,4.084,5.117,4.857,4.857,0,0,1-1.341.183,4.922,4.922,0,0,1-.965-.092,5.109,5.109,0,0,0,4.754,3.622,10.1,10.1,0,0,1-7.536,2.164,14.171,14.171,0,0,0,7.8,2.343c9.364,0,14.483-7.952,14.483-14.849,0-.227,0-.453-.012-.677a10.449,10.449,0,0,0,2.537-2.7,9.921,9.921,0,0,1-2.922.827A5.209,5.209,0,0,0,392.917,398.254Z",
    transform: "translate(919.171 4278.135)",
    fill: "#66aa47"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.f6cd1047482bb1ef8351654de4b2bede.svg";
export { ForwardRef as ReactComponent };